import { useContext, useEffect, useState } from "react";
import MainPriceComponent from "../../WorkSpace/ToolBarMenuViews/ProductsMenuView/Price/MainPriceComponent";
import {
  Container,
  Image,
  ImageWrapper,
  Name,
  Obs,
  getObsHeight,
} from "./EncarteProduct.styles";
import {
  SIMPLE_PROMOTION,
  getLayoutFontMultipliers,
} from "../../WorkSpace/CanvasViewer/EncarteConstants";
import WorkspaceContext from "../../WorkSpace/WorkspaceContext";
import Loading from "../Loading";
import ProductActionBox from "./ProductActionBox";
import useCanvasProductInteractions from "./useCanvasProductInteractions";

export default function Product({
  styles,
  product,
  canvasScale,
  index,
  isProductClickable,
  productsLength,
}) {
  const [productStyles, setProductStylesStyles] = useState();
  const [priceCommonMultiplier, setPriceCommonMultiplier] = useState(1);

  const { isDownloadingEncarteProductImages } = useContext(WorkspaceContext);
  const {
    isSelected,
    handleProductClick,
    handleEditClick,
    handleStyleClick,
    handleCloseClick,
  } = useCanvasProductInteractions({
    index,
    isProductClickable,
  });
  useEffect(() => {
    setProductStylesStyles(product.styles);
    let commonMultiplier = getLayoutFontMultipliers(
      product.styles.productLayout,
    ).priceMultiplier;
    if (product.promotionType !== SIMPLE_PROMOTION)
      commonMultiplier = commonMultiplier * 0.9;
    setPriceCommonMultiplier(commonMultiplier);
  }, [product.styles]);

  return (
    <>
      {productStyles ? (
        <Container
          selected={isSelected}
          isProductClickable={isProductClickable}
          productLayout={productStyles.productLayout}
          font={styles.fontFamily}
          txtColor={productStyles.txtColor}
          bgColor={productStyles.bgColor}
          canvasScale={canvasScale}
          className="product"
          key={`grid-product-${product.id}`}
          row={productStyles.gridRow}
          column={productStyles.gridColumn}
          name={product.name}
          productsLength={productsLength}
          obsHeight={
            product.obs ? getObsHeight(productStyles.fontSize, canvasScale) : 0
          }
          onClick={handleProductClick}
        >
          {isProductClickable && isSelected && (
            <ProductActionBox
              onEdit={handleEditClick}
              onStyle={handleStyleClick}
              onClose={handleCloseClick}
            />
          )}
          <ImageWrapper>
            {!product.displayUrl && isDownloadingEncarteProductImages && (
              <Loading
                txt={"Carregando imagem"}
                size={productStyles.fontSize}
              />
            )}
            <Image
              canvasScale={canvasScale}
              url={product.displayUrl}
              className="product-image"
              pId={product.id}
              imageZoom={productStyles.imageZoom}
            />
          </ImageWrapper>

          <Name
            productLayout={productStyles.productLayout}
            canvasScale={canvasScale}
            fontSize={productStyles.fontSize}
            nameMultiplier={
              getLayoutFontMultipliers(productStyles.productLayout)
                .nameMultiplier
            }
            bgColor={productStyles.bgColor}
            txtColor={productStyles.txtColor}
            className="product-name"
          >
            {product.name}
          </Name>

          <MainPriceComponent
            unity={product.measurement}
            styles={productStyles}
            position="relative"
            product={product}
            canvasScale={canvasScale}
            commonMultiplier={priceCommonMultiplier}
          />
          {product.obs && (
            <Obs
              canvasScale={canvasScale}
              fontSize={productStyles.fontSize}
              bgColor={productStyles.secondaryBgColor}
              txtColor={productStyles.secondaryTxtColor}
              className="product-obs"
            >
              {product.obs}
            </Obs>
          )}
        </Container>
      ) : (
        <Loading color={"black"} txt={"Carregando estilos"} />
      )}
    </>
  );
}
